import { render, staticRenderFns } from "./AffiliateGroups.create.vue?vue&type=template&id=60608737&"
import script from "./AffiliateGroups.create.vue?vue&type=script&lang=js&"
export * from "./AffiliateGroups.create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports